"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var PhoneShake = function PhoneShake(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M20.628 13.884a.488.488 0 01-.542-.42l-.584-5.316a.477.477 0 01.439-.519.488.488 0 01.542.42l.585 5.317a.478.478 0 01-.44.518zm-16.562 2.5a.488.488 0 01-.542-.42l-.585-5.316a.477.477 0 01.44-.519.488.488 0 01.541.42l.585 5.317a.477.477 0 01-.44.518zm1.35-7.81a.663.663 0 01.74.558l.845 7.493a.64.64 0 01-.599.69.663.663 0 01-.74-.56l-.844-7.492a.64.64 0 01.599-.69zm8.488-4.372a1.552 1.552 0 011.717 1.374l1.371 11.831a1.563 1.563 0 01-1.356 1.74l-5.533.658a1.552 1.552 0 01-1.717-1.375L7.015 6.6a1.563 1.563 0 011.356-1.74l5.533-.658zM9.507 17.35a.31.31 0 00.344.275l5.532-.658a.313.313 0 00.272-.348L14.5 6.656a.31.31 0 00-.343-.275l-5.533.658a.313.313 0 00-.271.348l1.154 9.963zm8.343-2.47l-.845-7.492a.64.64 0 01.6-.69.663.663 0 01.74.56l.844 7.492a.64.64 0 01-.6.69.663.663 0 01-.74-.56z"
  }));
};

var _default = (0, _react.forwardRef)(PhoneShake);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PhoneShake, "PhoneShake", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneShake.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneShake.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();